<template>
  <b-modal ref="modal" hide-footer title="Transfer Callbacks" size="lg">
    <b-row>
      <b-col md="11"></b-col>
      <b-col>
        <div v-if="!byUser">
          <b-badge pill variant="success">{{companyIds.length}}</b-badge>
        </div>
        <div v-if="byUser">
          <b-badge v-if="userSplits.length > 1 && !evenSplit && splitTotals < companyIds.length" pill variant="primary">{{splitTotals}}/{{companyIds.length}}</b-badge>
          <b-badge v-if="userSplits.length > 1 && !evenSplit && splitTotals > companyIds.length" pill variant="danger">{{splitTotals}}/{{companyIds.length}}</b-badge>
          <b-badge v-if="userSplits.length > 1 && !evenSplit && splitTotals === companyIds.length" pill variant="success">{{splitTotals}}/{{companyIds.length}}</b-badge>
          <b-badge v-if="userSplits.length <= 1 || evenSplit" pill variant="success">{{companyIds.length}}</b-badge>
        </div>


      </b-col>
    </b-row>

    <b-row>
      <b-col md="3"></b-col>
      <b-col md="3" class="label">
        <b-form-checkbox v-model="byUser">User</b-form-checkbox>
      </b-col>
      <b-col md="3" class="label">
        <b-form-checkbox v-model="byDate">Date</b-form-checkbox>
      </b-col>
    </b-row>
    <b-row v-if="byUser" class="my-1">
      <b-col md="3" class="label">
        <label for="noteType">Transfer to User</label>
      </b-col>
      <b-col md="6">
        <multiselect v-model="selectedUsers"
                     label="fullName"
                     track-by="id"
                     :options="users"
                     :multiple="true"
                     :hide-selected="true"></multiselect>
      </b-col>
      <b-col md="2">
        <b-form-checkbox v-if="selectedUsers.length > 1" v-model="evenSplit">Even Split</b-form-checkbox>

      </b-col>

    </b-row>

    <div v-for="item in userSplits" :key="item.id">
      <b-row v-if="byUser && !evenSplit" class="my-1">
        <b-col md="4"></b-col>
        <b-col md="2" class="label">
          <label for="noteType">{{item.fullName}}</label>
        </b-col>
        <b-col md="3">
          <b-form-input type="number" v-model="item.value" @keyup="calculateUsersplits"></b-form-input>
        </b-col>

      </b-row>
    </div>

    <b-row v-if="byDate" class="my-1">
      <b-col md="3" class="label">
        <label for="noteType">Transfer Dates</label>
      </b-col>
      <b-col md="4">
        <div v-for="item in selectedDate" :key="item.id">
          <b-form-datepicker v-model="item.date"
                             :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
                             locale="en-GB"></b-form-datepicker>
        </div>
      </b-col>

      <b-col>
        <b-button type="submit" variant="success" class="margin-right" @click="addDate" :disabled="!validDate">
          <font-awesome-icon icon="plus" /> Add Date
        </b-button>
        <b-button type="submit" variant="success" class="margin-right" @click="deleteDate" :disabled="selectedDate.length === 1">
          <font-awesome-icon icon="times" /> Delete Date
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mb-2"></b-row>
    <b-row class="mb-2"></b-row>
    <b-row class="mb-2"></b-row>
    <b-row class="my-1">
      <b-col md="3">
      </b-col>
      <b-col md="9">
        <FeedbackButton title="Save" icon="save" :busy="isBusy" :disabled="!modalValid" :onClick="save" />
        <b-button type="reset" variant="danger" @click="cancel">
          <font-awesome-icon icon="times" /> Cancel Changes
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
  import Multiselect from "vue-multiselect";
  import CallbackService from '@/services/Callback.service'
  import FeedbackButton from "@/components/shared/FeedbackButton.vue";

  export default {
    components: { Multiselect, FeedbackButton },
    props: ['users', 'companyIds'],
    data() {
      return {
        byUser: true,
        byDate: false,
        selectedUsers: [],
        selectedDate: [{ id: 1, date: '' }],
        evenSplit: true,
        userSplits: [],
        splitTotals: 0,
        isBusy: false,
      }
    },

    created() {
      //this.selectedDate.push({ id: 1, date: '' });
    },
    computed: {
      modalValid() {
        var isValid = true;
        if (this.byUser && this.selectedUsers.length === 0) {
          isValid = false;
        }
        if (this.byDate && this.selectedDate[this.selectedDate.length - 1].date === '') {
          isValid = false;
        }
        if (this.byUser && !this.evenSplit && this.splitTotals != this.companyIds.length) {
          isValid = false;
        }
        return isValid;
      },
      validDate() {
        if (this.selectedDate[this.selectedDate.length - 1].date !== '') {
          return true;
        }
        return false;
      },
    },
    watch: {
      selectedUsers: {
        handler: function (val, oldVal) {
          var removed = oldVal.filter(x => !val.includes(x))
          var added = val.filter(x => !oldVal.includes(x));
          added.forEach(x => {
            this.userSplits.push({ id: x.id, value: '', fullName: x.fullName });
          })
          removed.forEach(x => {
            this.userSplits = this.userSplits.filter(y => {
              return x.id != y.id;
            })
          });

          this.calculateUsersplits();
        }, deep: true
      }
    },
    methods: {
      showModal() {
        this.$refs["modal"].show();
      },
      hideModal() {
        this.$refs["modal"].hide();
      },
      cancel() {
        this.clear();
        this.$refs["modal"].hide();
      },
      save() {
        this.isBusy = true;
        var selectedDates = [];
        var userSplits = [];
        if (this.byDate) {
          selectedDates = this.selectedDate.map(x => x.date);
        }
        if (this.byUser && this.evenSplit) {
          this.selectedUsers.forEach(x => {
            userSplits.push({ id: x.id, value: 0 })
          })
        }
        if (this.byUser && !this.evenSplit) {
          userSplits = this.userSplits;
        }

        var form = {
          selectedUsers: userSplits,
          selectedDates: selectedDates,
          companyIds: this.companyIds,

        }
        CallbackService.transferCallbacks(form).then(() => {
          this.isBusy = false;
          this.clear();
          this.$parent.clickSearch();
          this.$refs["modal"].hide();
        }).catch(() => {
          this.isBusy = false;
        })

      },
      clear() {
        this.byUser = true;
        this.byDate = false;
        this.selectedUsers = [];
        this.selectedDate = [{ id: 1, date: '' }];
        this.evenSplit = true;
        this.userSplits = [];
        this.splitTotals = 0;
      },
      addDate() {
        var newId = this.selectedDate.length + 1
        this.selectedDate.push({ id: newId, date: '' });
      },
      deleteDate() {
        if (this.selectedDate.length > 1) {
          this.selectedDate.splice(this.selectedDate.length - 1, 1);
        }

      },
      calculateUsersplits() {
        var total = parseInt(0);
        this.userSplits.forEach(x => {
          if (x.value != '') {
            total += parseInt(x.value);
          }

        });
        this.splitTotals = total;
      }
    }
  }
</script>


